export function ListIcon() {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 9H31.5" stroke="#636363" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 18H31.5" stroke="#636363" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 27H31.5" stroke="#636363" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.5 9H4.51549" stroke="#636363" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.5 18H4.51549" stroke="#636363" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.5 27H4.51549" stroke="#636363" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}